import { NgModule } from '@angular/core';
import { declarations } from './declarations.organizer';
import { imports } from './imports.organizer';
import { RouterModule } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import {
  CURRENCY_MASK_CONFIG,
  CurrencyMaskConfig,
  CurrencyMaskModule,
} from 'ng2-currency-mask';
import { providers } from './services.organizer';
import { NgApexchartsModule } from 'ng-apexcharts';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM/YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MM/YYYY',
  },
};

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
};

@NgModule({
  declarations: [declarations],
  imports: [
    imports,
    RouterModule,
    CommonModule,
    TranslocoModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    CurrencyMaskModule,
    FormsModule,
  ],
  exports: [
    declarations,
    imports,
    ReactiveFormsModule,
    TranslocoModule,
    CurrencyMaskModule,
    FormsModule,
    NgApexchartsModule,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  providers: [
    providers,
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'pt-br',
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    provideNgxMask(),
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    DatePipe,
    NgxMaskPipe,
  ],
})
export class SharedModule {}
